<template>
<el-dialog title="审核记录" :visible="shjlFlag" width="1000px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
  <div>
    <el-table height="400px" size="mini" ref="tabref" :data="SHXQlist" style="width:100%"  border center>
      <el-table-column type="index"  label="序号" width="60"></el-table-column>
      <el-table-column prop="auditState" label="审核状态" width="100">
      <template slot-scope="scope">
        <span>{{['审核通过','审核驳回','待审核','撤销审核'][scope.row.auditState]}}</span>
      </template>
    </el-table-column>
      <el-table-column prop="auditRemark" :formatter="formatterRowEmpty" min-width="200" label="审核原因"></el-table-column>
      <el-table-column prop="auditUserName" min-width="120"  label="审核人"></el-table-column>
      <el-table-column prop="auditTime" min-width="170" :formatter="dateTimeFormat" label="审核时间"></el-table-column>
    </el-table>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">关闭</el-button>
  </span>
</el-dialog>
</template>
<script>
import { tAuditRecordList } from '@/api/newTMS'
import { emptyFn, encryption, dateTimeFormat } from '@/utils/util'
export default {
  name: 'xiugaiSG',
  props: {
    shjlFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      isDisable: false,
      SHXQlist: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    tAuditRecordList({ businessType: 3, businessTableId: this.rowData.id }).then(res => {
      this.SHXQflag = true
      this.SHXQlist = res
    })
  },
  methods: {
    closeDialog () {
      this.$emit('update:shjlFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>
.AMarkFoot {
  font-size: 14px;
  bottom: 10px;
  width: 100%;
  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
</style>
